(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powdi-articles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const init = (root) => {
      if (!root || root.dataset.articlesReady === 'true') return;

      const scroller = root.querySelector('[data-articles-scroller]');
      const fill = root.querySelector('[data-articles-fill]');
      const progress = root.querySelector('[data-articles-progress]');
      const next = root.querySelector('[data-articles-next]');
      const prev = root.querySelector('[data-articles-prev]');
      if (!scroller) return;

      root.dataset.articlesReady = 'true';

      const step = () => {
        const slide = scroller.querySelector('[data-articles-slide]');
        if (!slide) return 0;
        const styles = window.getComputedStyle(scroller);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return slide.getBoundingClientRect().width + gap;
      };

      const update = () => {
        const max = scroller.scrollWidth - scroller.clientWidth;
        const atStart = scroller.scrollLeft <= 2;
        const atEnd = max <= 1 || scroller.scrollLeft >= max - 2;
        const desktop = window.matchMedia('(min-width: 768px)').matches;

        if (next) {
          next.hidden = desktop === false;
          next.disabled = atEnd;
        }

        if (prev) {
          prev.hidden = desktop === false;
          prev.disabled = atStart;
        }

        if (!progress || !fill) return;
        if (window.matchMedia('(min-width: 768px)').matches || max <= 1) {
          progress.hidden = true;
          return;
        }

        progress.hidden = false;
        fill.style.width = `${(scroller.clientWidth / scroller.scrollWidth) * 100}%`;
        fill.style.left = `${(scroller.scrollLeft / scroller.scrollWidth) * 100}%`;
      };

      if (next) {
        next.addEventListener('click', () => {
          scroller.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      if (prev) {
        prev.addEventListener('click', () => {
          scroller.scrollBy({ left: step() * -1, behavior: 'smooth' });
        });
      }

      scroller.addEventListener('scroll', update, { passive: true });
      scroller.addEventListener('scrollend', update);
      window.addEventListener('resize', update);
      update();
    };

    const boot = () => {
      document.querySelectorAll('[data-powdi-articles]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-powdi-articles]');
      if (root) {
        delete root.dataset.articlesReady;
        init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powdi-bundles-mix"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const init = (root) => {
      if (!root || root.dataset.bundlesReady === 'true') return;

      const scroller = root.querySelector('[data-bundles-scroller]');
      const fill = root.querySelector('[data-bundles-fill]');
      const progress = root.querySelector('[data-bundles-progress]');
      const prev = root.querySelector('[data-bundles-prev]');
      const next = root.querySelector('[data-bundles-next]');
      if (!scroller || !fill || !progress) return;

      root.dataset.bundlesReady = 'true';

      const desktop = () => window.matchMedia('(min-width: 768px)').matches;

      const step = () => {
        const slide = scroller.querySelector('.powdi-bundles__slide');
        if (!slide) return scroller.clientWidth;
        const styles = window.getComputedStyle(scroller);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return slide.getBoundingClientRect().width + gap;
      };

      const update = () => {
        const max = scroller.scrollWidth - scroller.clientWidth;
        if (desktop()) {
          progress.hidden = true;
          if (prev) prev.disabled = scroller.scrollLeft <= 2;
          if (next) next.disabled = max <= 2 || scroller.scrollLeft >= max - 2;
          return;
        }

        if (prev) prev.disabled = true;
        if (next) next.disabled = true;
        if (max <= 1) {
          progress.hidden = true;
          return;
        }

        progress.hidden = false;
        const ratio = scroller.clientWidth / scroller.scrollWidth;
        const left = scroller.scrollLeft / scroller.scrollWidth;
        fill.style.width = `${ratio * 100}%`;
        fill.style.left = `${left * 100}%`;
      };

      const scrollByStep = (direction) => {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        scroller.scrollBy({
          left: direction * step(),
          behavior: reduce ? 'auto' : 'smooth',
        });
      };

      if (prev) {
        prev.addEventListener('click', () => scrollByStep(-1));
      }
      if (next) {
        next.addEventListener('click', () => scrollByStep(1));
      }

      scroller.addEventListener('scroll', update, { passive: true });
      scroller.addEventListener('scrollend', update);
      window.addEventListener('resize', update);
      update();
    };

    const boot = () => {
      document.querySelectorAll('[data-powdi-bundles]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-powdi-bundles]');
      if (root) {
        delete root.dataset.bundlesReady;
        init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powdi-community-favorites"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const init = (root) => {
      if (!root || root.dataset.favoritesReady === 'true') return;

      const scroller = root.querySelector('[data-favorites-scroller]');
      const fill = root.querySelector('[data-favorites-fill]');
      const progress = root.querySelector('[data-favorites-progress]');
      if (!scroller || !fill || !progress) return;

      root.dataset.favoritesReady = 'true';

      const update = () => {
        if (window.matchMedia('(min-width: 768px)').matches) {
          progress.hidden = true;
          return;
        }

        const max = scroller.scrollWidth - scroller.clientWidth;
        if (max <= 1) {
          progress.hidden = true;
          return;
        }

        progress.hidden = false;
        const ratio = scroller.clientWidth / scroller.scrollWidth;
        const left = scroller.scrollLeft / scroller.scrollWidth;
        fill.style.width = `${ratio * 100}%`;
        fill.style.left = `${left * 100}%`;
      };

      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    };

    const boot = () => {
      document.querySelectorAll('[data-powdi-favorites]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-powdi-favorites]');
      if (root) {
        delete root.dataset.favoritesReady;
        init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powdi-footer"] && !Shopify.designMode) return;
  try {
    
  const consentFallback = 'Pažymėk šį laukelį, jei nori tęsti.';
  const emailMissingFallback = 'Įrašyk el. pašto adresą.';
  const emailInvalidFallback = 'Įrašyk teisingą el. pašto adresą.';

  const prepare = (el) => {
    if (!el || typeof el.setCustomValidity !== 'function') return;
    if (el.type === 'checkbox') {
      const message = el.getAttribute('data-powdi-message') || consentFallback;
      el.setCustomValidity(el.checked ? '' : message);
      return;
    }
    if (el.validity.valueMissing) {
      el.setCustomValidity(el.getAttribute('data-powdi-missing') || emailMissingFallback);
    } else if (el.validity.typeMismatch) {
      el.setCustomValidity(el.getAttribute('data-powdi-invalid') || emailInvalidFallback);
    } else {
      el.setCustomValidity('');
    }
  };

  const prepareForm = (form) => {
    if (!form) return;
    form.querySelectorAll('[data-powdi-consent], [data-powdi-email]').forEach(prepare);
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('button, input[type="submit"]');
      if (!button) return;
      prepareForm(button.form || button.closest('form'));
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter' || !event.target.form) return;
      prepareForm(event.target.form);
    },
    true
  );

  document.addEventListener('input', (event) => {
    const el = event.target;
    if (!el || !el.hasAttribute) return;
    if (!el.hasAttribute('data-powdi-consent') && !el.hasAttribute('data-powdi-email')) return;
    el.setCustomValidity('');
  });

  const posted = document.querySelector('#powdi-footer-newsletter .powdi-footer__message:not([hidden]), #powdi-blog-newsletter .powdi-blog-nl__message:not([hidden])');
  if (posted) posted.scrollIntoView({ block: 'center' });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powdi-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('powdi-header')) {
    class PowdiHeader extends HTMLElement {
      connectedCallback() {
        this.mega = this.querySelector('[data-powdi-mega]');
        this.trigger = this.querySelector('[data-powdi-mega-trigger]');
        this.drawer = this.querySelector('[data-powdi-drawer]');
        this.sectionEl = this.closest('.header-section');
        this.onDocClick = this.onDocClick.bind(this);
        this.onKey = this.onKey.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.lastScroll = 0;

        this.trigger?.addEventListener('click', () => this.toggleMega());
        this.trigger?.addEventListener('mouseenter', () => this.onMegaEnter());
        this.trigger?.addEventListener('mouseleave', () => this.onMegaLeave());
        this.mega?.addEventListener('mouseenter', () => this.onMegaEnter());
        this.mega?.addEventListener('mouseleave', () => this.onMegaLeave());
        this.querySelectorAll('[data-powdi-category]').forEach((el) => {
          const show = () => this.selectCategory(el.dataset.powdiCategory);
          el.addEventListener('mouseenter', show);
          el.addEventListener('focus', show);
          el.addEventListener('click', show);
        });
        this.querySelector('[data-powdi-drawer-open]')?.addEventListener('click', () => {
          if (this.classList.contains('is-drawer-open')) this.closeDrawer();
          else this.openDrawer();
        });
        this.querySelectorAll('[data-powdi-drawer-close]').forEach((btn) => {
          btn.addEventListener('click', () => this.closeDrawer());
        });
        this.querySelectorAll('[data-powdi-drawer-cat]').forEach((btn) => {
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            this.openDrawerSub(btn.dataset.powdiDrawerCat);
          });
        });
        this.querySelectorAll('[data-powdi-drawer-back]').forEach((btn) => {
          btn.addEventListener('click', () => this.closeDrawerSub());
        });
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKey);
        this.onCartUpdate = this.onCartUpdate.bind(this);
        document.addEventListener('shopify:cart:lines-update', this.onCartUpdate);
        this.scroller = document.querySelector('.page-wrapper') || window;
        this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.innerEl = this.querySelector('.powdi-header__inner');
        this.desktopBar = this.querySelector('.powdi-header__bar--desktop');
        this.navCluster = this.querySelector('.powdi-header__cluster--nav');
        this.actionsCluster = this.querySelector('.powdi-header__cluster--actions');
        this.syncNavFit = this.syncNavFit.bind(this);
        this.onNavMedia = this.syncNavFit;
        this.navMedia = window.matchMedia('(min-width: 990px)');
        this.wideMedia = window.matchMedia('(min-width: 1200px)');
        this.navMedia.addEventListener('change', this.onNavMedia);
        this.wideMedia.addEventListener('change', this.onNavMedia);
        window.addEventListener('resize', this.syncNavFit);
        this.fitObserver = new ResizeObserver(() => {
          this.syncHeight();
          this.syncNavFit();
        });
        this.fitObserver.observe(this);
        if (this.innerEl) this.fitObserver.observe(this.innerEl);
        if (this.desktopBar) this.fitObserver.observe(this.desktopBar);
        if (this.navCluster) this.fitObserver.observe(this.navCluster);
        if (this.actionsCluster) this.fitObserver.observe(this.actionsCluster);
        this.syncHeight();
        this.syncNavFit();
        requestAnimationFrame(() => this.syncNavFit());
        document.fonts?.ready?.then(this.syncNavFit);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('shopify:cart:lines-update', this.onCartUpdate);
        this.scroller?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.syncNavFit);
        this.navMedia?.removeEventListener('change', this.onNavMedia);
        this.wideMedia?.removeEventListener('change', this.onNavMedia);
        this.fitObserver?.disconnect();
      }

      syncHeight() {
        const height = getComputedStyle(document.body).getPropertyValue('--header-height').trim();
        if (height) {
          document.body.style.setProperty('--header-group-height', height);
        }
      }

      isDesktopMedia() {
        return (this.navMedia || window.matchMedia('(min-width: 990px)')).matches;
      }

      isDesktopNav() {
        if (!this.isDesktopMedia() || this.classList.contains('is-compact')) return false;
        if (this.classList.contains('is-expanded')) return true;
        return (this.wideMedia || window.matchMedia('(min-width: 1200px)')).matches;
      }

      syncNavFit() {
        if (!this.desktopBar || !this.innerEl) return;

        if (!this.isDesktopMedia()) {
          if (this.classList.contains('is-compact') || this.classList.contains('is-expanded')) {
            this.classList.remove('is-compact', 'is-expanded');
            this.syncHeight();
          }
          return;
        }

        const navCluster = this.navCluster || this.querySelector('.powdi-header__cluster--nav');
        const actions = this.actionsCluster || this.querySelector('.powdi-header__cluster--actions');
        if (!navCluster || !actions || navCluster.offsetWidth < 40 || actions.offsetWidth < 40) return;

        const gap = Number.parseFloat(getComputedStyle(this.desktopBar).gap) || 8;
        const needed = navCluster.offsetWidth + gap + actions.offsetWidth;
        const available = this.innerEl.clientWidth;
        const compact = this.classList.contains('is-compact');
        const nextCompact = compact ? needed > available - 16 : needed > available - 8;

        this.classList.toggle('is-compact', nextCompact);
        this.classList.toggle('is-expanded', !nextCompact);

        if (nextCompact === compact) return;

        if (nextCompact) this.closeMega();
        else this.closeDrawer();
        this.syncHeight();
      }

      onMegaEnter() {
        if (!this.isDesktopNav()) return;
        clearTimeout(this.megaCloseTimer);
        this.openMega();
      }

      onMegaLeave() {
        if (!this.isDesktopNav()) return;
        clearTimeout(this.megaCloseTimer);
        this.megaCloseTimer = setTimeout(() => this.closeMega(), 120);
      }

      toggleMega() {
        if (!this.mega) return;
        if (this.mega.hasAttribute('hidden')) this.openMega();
        else this.closeMega();
      }

      openMega() {
        if (!this.mega || !this.isDesktopNav()) return;
        this.mega.removeAttribute('hidden');
        this.trigger?.setAttribute('aria-expanded', 'true');
        this.trigger?.classList.add('is-open');
      }

      closeMega() {
        if (!this.mega || this.mega.hasAttribute('hidden')) return;
        clearTimeout(this.megaCloseTimer);
        this.mega.setAttribute('hidden', '');
        this.trigger?.setAttribute('aria-expanded', 'false');
        this.trigger?.classList.remove('is-open');
      }

      selectCategory(id) {
        if (!id) return;
        this.querySelectorAll('[data-powdi-category]').forEach((el) => {
          el.classList.toggle('is-active', el.dataset.powdiCategory === id);
        });
        this.mega?.querySelectorAll('[data-powdi-panel]').forEach((panel) => {
          panel.toggleAttribute('hidden', panel.dataset.powdiId !== id);
        });
      }

      openDrawer() {
        if (!this.drawer) return;
        this.closeDrawerSub();
        this.drawer.removeAttribute('hidden');
        this.classList.add('is-drawer-open');
        this.querySelector('[data-powdi-drawer-open]')?.setAttribute('aria-expanded', 'true');
        document.documentElement.setAttribute('scroll-lock', '');
      }

      closeDrawer() {
        if (!this.drawer) return;
        this.drawer.setAttribute('hidden', '');
        this.classList.remove('is-drawer-open');
        this.querySelector('[data-powdi-drawer-open]')?.setAttribute('aria-expanded', 'false');
        document.documentElement.removeAttribute('scroll-lock');
        this.closeDrawerSub();
      }

      openDrawerSub(id) {
        if (!id) return;
        this.querySelector('[data-powdi-drawer-root]')?.setAttribute('hidden', '');
        let opened = null;
        this.querySelectorAll('[data-powdi-drawer-sub]').forEach((panel) => {
          const show = panel.dataset.powdiId === id;
          panel.toggleAttribute('hidden', !show);
          if (show) opened = panel;
        });
        this.classList.add('is-drawer-sub');
        const body = this.querySelector('.powdi-header__drawer-body');
        if (body) body.scrollTop = 0;
        if (opened) this.reviveDrawerImages(opened);
      }

      reviveDrawerImages(panel) {
        panel.querySelectorAll('img').forEach((img) => {
          img.loading = 'eager';
          if (!img.complete || img.naturalWidth > 0) return;
          const src = img.getAttribute('src');
          const srcset = img.getAttribute('srcset');
          if (!src && !srcset) return;
          img.removeAttribute('src');
          if (srcset) img.removeAttribute('srcset');
          if (srcset) img.setAttribute('srcset', srcset);
          if (src) img.setAttribute('src', src);
        });
      }

      closeDrawerSub() {
        this.classList.remove('is-drawer-sub');
        this.querySelector('[data-powdi-drawer-root]')?.removeAttribute('hidden');
        this.querySelectorAll('[data-powdi-drawer-sub]').forEach((panel) => {
          panel.setAttribute('hidden', '');
        });
      }

      onDocClick(event) {
        if (!this.contains(event.target)) this.closeMega();
      }

      onKey(event) {
        if (event.key !== 'Escape') return;
        if (this.classList.contains('is-drawer-sub')) {
          this.closeDrawerSub();
          return;
        }
        this.closeMega();
        this.closeDrawer();
      }

      onCartUpdate(event) {
        event.promise
          ?.then(({ cart, detail }) => {
            const itemCount = cart?.totalQuantity ?? detail?.itemCount ?? 0;
            this.querySelectorAll('.powdi-header__cart').forEach((button) => {
              const count = button.querySelector('.powdi-header__cart-count');
              if (count) count.textContent = String(itemCount);
              const label = button.dataset.cartLabel;
              if (label) button.setAttribute('aria-label', label + ': ' + itemCount);
            });
          })
          .catch(() => {});
      }

      onScroll() {
        if (this.classList.contains('is-drawer-open')) return;
        const wrap = this.scroller && this.scroller !== window ? this.scroller : null;
        const wrapScrolls = wrap && wrap.scrollHeight > wrap.clientHeight + 10;
        const top = wrapScrolls ? wrap.scrollTop : window.scrollY;
        if (top <= 8) {
          this.sectionEl?.classList.remove('is-powdi-hidden');
          this.lastScroll = top;
          return;
        }
        const delta = top - this.lastScroll;
        if (delta > 8 && top > 80) {
          this.sectionEl?.classList.add('is-powdi-hidden');
          this.closeMega();
          this.lastScroll = top;
        } else if (delta < -8) {
          this.sectionEl?.classList.remove('is-powdi-hidden');
          this.lastScroll = top;
        }
      }
    }

    customElements.define('powdi-header', PowdiHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powdi-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const PER_PAGE = 20;
    const SHOW = 12;
    const GENERIC_WORDS = new Set([
      'powdi',
      'anonimas',
      'anonymous',
      'anonimous',
      'guest',
      'n/a',
      'pirkėjas',
      'pirkejas',
      'buyer',
      'customer',
      'klientas',
      'svečias',
      'svecias',
    ]);

    const shuffle = (list) => {
      for (let i = list.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        const swap = list[i];
        list[i] = list[j];
        list[j] = swap;
      }
      return list;
    };

    const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();

    const isAnonymous = (name) => {
      const words = clean(name)
        .toLowerCase()
        .replace(/[.]/g, '')
        .split(/\s+/)
        .filter(Boolean);
      return words.length === 0 || words.every((word) => GENERIC_WORDS.has(word));
    };

    const quoteOf = (review) => {
      const body = clean(review.body);
      const title = clean(review.title);
      if (!body) return title;
      if (!title || body.toLowerCase().startsWith(title.toLowerCase())) return body;
      return title + '. ' + body;
    };

    const productPath = (url) => {
      if (!url) return '';
      const path = url.split('?')[0].split('#')[0];
      const match = path.match(/\/products\/([a-z0-9][a-z0-9\-_%]*)/i);
      return match ? '/products/' + match[1] : '';
    };

    const formatMoney = (cents, format) => {
      const pattern = format || '€{{amount_with_comma_separator}}';
      const value = Number(cents || 0) / 100;
      const amount = value.toFixed(2);
      const comma = amount.replace('.', ',');
      const noDecimals = String(Math.round(value));
      const noDecimalsComma = noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return pattern
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, comma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimalsComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, amount.replace('.', "'"))
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    };

    const imageSrc = (product, variant) => {
      const featured = variant && variant.featured_image;
      const raw = (featured && featured.src) || product.featured_image || '';
      if (!raw) return '';
      const absolute = raw.startsWith('//') ? 'https:' + raw : raw;
      if (!/^https:\/\/cdn\.shopify\.com\//.test(absolute)) return '';
      return absolute + (absolute.includes('?') ? '&' : '?') + 'width=160';
    };

    const netWeights = (() => {
      const node = document.querySelector('[data-net-weights]');
      if (!node) return {};
      try {
        const parsed = JSON.parse(node.textContent || '{}');
        return parsed && typeof parsed === 'object' ? parsed : {};
      } catch (error) {
        return {};
      }
    })();

    const weightLabel = (variant, product) => {
      if (!variant) return '';
      const title = clean(variant.title);
      if (title && title !== 'Default Title') return title;
      const handle = product && product.handle;
      return handle ? clean(netWeights[handle]) : '';
    };

    const parseReviews = (html) => {
      const doc = new DOMParser().parseFromString(html || '', 'text/html');
      return Array.from(doc.querySelectorAll('.jdgm-rev')).map((node) => {
        const link = node.querySelector('.jdgm-rev__prod-link');
        return {
          id: node.getAttribute('data-review-id') || '',
          author: clean(node.querySelector('.jdgm-rev__author')?.textContent),
          rating: Number(node.querySelector('.jdgm-rev__rating')?.getAttribute('data-score')),
          title: clean(node.querySelector('.jdgm-rev__title')?.textContent),
          body: clean(node.querySelector('.jdgm-rev__body')?.textContent),
          productTitle: clean(link?.textContent),
          productUrl: productPath(link?.getAttribute('href') || ''),
        };
      });
    };

    const fetchPage = async (shop, page, perPage) => {
      const params = new URLSearchParams({
        url: shop,
        shop_domain: shop,
        platform: 'shopify',
        page: String(page),
        per_page: String(perPage),
        review_type: 'product-reviews',
      });
      const response = await fetch('https://cdn.judge.me/reviews/all_reviews_js_based?' + params, {
        credentials: 'omit',
      });
      if (!response.ok) throw new Error('reviews');
      return response.json();
    };

    const namedReviews = (html) =>
      parseReviews(html).filter(
        (review) =>
          review.rating >= 4 && !isAnonymous(review.author) && quoteOf(review) && review.productUrl
      );

    const loadPool = async (shop) => {
      const first = await fetchPage(shop, 1, 1);
      const total = Number(first.number_of_product_reviews || 0);
      const pages = Math.max(1, Math.ceil((total || PER_PAGE) / PER_PAGE));
      const start = 1 + Math.floor(Math.random() * pages);
      const pool = [];
      const seen = new Set();
      const authorKey = (review) => clean(review.author).toLowerCase();
      const uniqueCount = (list) => new Set(list.map(authorKey)).size;
      const limit = Math.min(pages, 15);
      for (let offset = 0; offset < limit && uniqueCount(pool) < SHOW; offset += 1) {
        const page = ((start - 1 + offset) % pages) + 1;
        const payload = await fetchPage(shop, page, PER_PAGE);
        namedReviews(payload.html).forEach((review) => {
          const key = review.id || review.author + quoteOf(review);
          if (seen.has(key)) return;
          seen.add(key);
          pool.push(review);
        });
      }
      return pool;
    };

    const pickReviews = (pool) => {
      const shuffled = shuffle(pool.slice());
      const seen = new Set();
      const picked = [];
      shuffled.forEach((review) => {
        const key = clean(review.author).toLowerCase();
        if (seen.has(key)) return;
        seen.add(key);
        picked.push(review);
      });
      if (picked.length < SHOW) {
        shuffled.forEach((review) => {
          if (picked.length >= SHOW || picked.includes(review)) return;
          picked.push(review);
        });
      }
      return picked.slice(0, SHOW);
    };

    const loadProduct = async (path) => {
      const response = await fetch(path + '.js', { credentials: 'same-origin' });
      if (!response.ok) return null;
      return response.json();
    };

    const cloneArrow = (root, uid) => {
      const template = root.querySelector('[data-reviews-arrow]');
      if (!template) return document.createDocumentFragment();
      const fragment = template.content.cloneNode(true);
      const ids = new Map();
      fragment.querySelectorAll('[id]').forEach((el) => {
        const next = (el.id + '-' + uid).replace(/\s+/g, '-');
        ids.set(el.id, next);
        el.id = next;
      });
      fragment.querySelectorAll('[mask]').forEach((el) => {
        const mask = el.getAttribute('mask') || '';
        const match = mask.match(/^url\(#(.+)\)$/);
        if (match && ids.has(match[1])) el.setAttribute('mask', 'url(#' + ids.get(match[1]) + ')');
      });
      return fragment;
    };

    const buildSlide = (root, review, product) => {
      const variant = product && ((product.variants || []).find((item) => item.available) || product.variants?.[0]);
      const quote = quoteOf(review);
      const rating = Math.min(5, Math.max(1, Number.isFinite(review.rating) ? review.rating : 5));
      const slide = document.createElement('li');
      slide.className = 'powdi-reviews__slide';
      slide.setAttribute('data-reviews-slide', '');

      const card = document.createElement('article');
      card.className = 'powdi-reviews__card';

      const top = document.createElement('div');
      top.className = 'powdi-reviews__top';
      const author = document.createElement('h3');
      author.className = 'powdi-reviews__author';
      author.textContent = review.author;
      const stars = document.createElement('div');
      stars.className = 'powdi-reviews__stars';
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', rating + ' iš 5');
      for (let i = 1; i <= 5; i += 1) {
        const star = document.createElement('img');
        star.className = 'powdi-reviews__star' + (i > rating ? ' is-empty' : '');
        star.src = root.dataset.starSrc || '';
        star.alt = '';
        star.width = 24;
        star.height = 23;
        stars.append(star);
      }
      top.append(author, stars);

      const quoteEl = document.createElement('p');
      quoteEl.className = 'powdi-reviews__quote';
      quoteEl.textContent = quote;
      card.append(top, quoteEl);

      const path = review.productUrl;
      if (path) {
        const wrap = document.createElement('div');
        wrap.className = 'powdi-reviews__product-wrap';
        const rule = document.createElement('div');
        rule.className = 'powdi-reviews__rule';
        const label = document.createElement('p');
        label.className = 'powdi-reviews__product-label';
        label.textContent = root.dataset.productLabel || 'Produktas';
        const link = document.createElement('a');
        link.className = 'powdi-reviews__product';
        link.href = path;

        const thumb = document.createElement('span');
        thumb.className = 'powdi-reviews__thumb';
        const src = product ? imageSrc(product, variant) : '';
        if (src) {
          const image = document.createElement('img');
          image.className = 'powdi-reviews__thumb-img';
          image.src = src;
          image.alt = review.productTitle || (product && product.title) || '';
          image.width = 80;
          image.height = 80;
          image.loading = 'lazy';
          thumb.append(image);
        }

        const copy = document.createElement('span');
        copy.className = 'powdi-reviews__product-copy';
        const title = document.createElement('span');
        title.className = 'powdi-reviews__product-title';
        title.textContent = (product && product.title) || review.productTitle;
        copy.append(title);
        const weight = weightLabel(variant, product);
        if (weight) {
          const weightEl = document.createElement('span');
          weightEl.className = 'powdi-reviews__product-weight';
          weightEl.textContent = weight;
          copy.append(weightEl);
        }
        if (variant) {
          const price = document.createElement('span');
          price.className = 'powdi-reviews__product-price';
          price.textContent = formatMoney(variant.price, root.dataset.moneyFormat);
          copy.append(price);
        }

        const go = document.createElement('span');
        go.className = 'powdi-reviews__product-go';
        go.setAttribute('aria-hidden', 'true');
        go.append(cloneArrow(root, review.id || String(Math.random()).slice(2)));
        link.append(thumb, copy, go);
        wrap.append(rule, label, link);
        card.append(wrap);
      }

      slide.append(card);
      return slide;
    };

    const fillReviews = async (root) => {
      const track = root.querySelector('[data-reviews-track]');
      const shop = root.dataset.shop;
      if (!track || !shop || root.dataset.reviewsLoading === 'true') return;
      root.dataset.reviewsLoading = 'true';
      root.setAttribute('aria-busy', 'true');
      try {
        const pool = pickReviews(await loadPool(shop));
        const paths = Array.from(new Set(pool.map((review) => review.productUrl)));
        const products = new Map();
        await Promise.all(
          paths.map(async (path) => {
            try {
              products.set(path, await loadProduct(path));
            } catch (error) {
              products.set(path, null);
            }
          })
        );
        track.replaceChildren();
        pool.forEach((review) => {
          track.append(buildSlide(root, review, products.get(review.productUrl)));
        });
      } catch (error) {
        track.replaceChildren();
      } finally {
        root.dataset.reviewsLoading = 'false';
        root.setAttribute('aria-busy', 'false');
      }
    };

    const init = (root) => {
      if (!root || root.dataset.reviewsReady === 'true') return;

      const track = root.querySelector('[data-reviews-track]');
      const viewport = root.querySelector('[data-reviews-viewport]');
      const slides = root.querySelectorAll('[data-reviews-slide]');
      const prev = root.querySelector('[data-reviews-prev]');
      const next = root.querySelector('[data-reviews-next]');
      const progress = root.querySelector('[data-reviews-progress]');
      const fill = root.querySelector('[data-reviews-fill]');
      if (!track || slides.length === 0) return;

      root.dataset.reviewsReady = 'true';

      let index = 0;
      const desktopQuery = window.matchMedia('(min-width: 768px)');
      const wideQuery = window.matchMedia('(min-width: 1100px)');
      const isDesktop = () => desktopQuery.matches;
      const visibleCount = () => {
        if (wideQuery.matches) return 3;
        if (isDesktop()) return 2;
        return 1;
      };
      const maxIndex = () => Math.max(0, slides.length - visibleCount());

      const updateProgressFromScroll = () => {
        if (!progress || !fill || !viewport) return;
        const max = viewport.scrollWidth - viewport.clientWidth;
        if (max <= 1) {
          progress.hidden = true;
          return;
        }
        progress.hidden = false;
        const seen = Math.min(1, viewport.scrollLeft / max);
        fill.style.left = '0';
        fill.style.width = seen * 100 + '%';
      };

      const update = () => {
        if (!isDesktop()) {
          track.style.transform = '';
          if (prev) prev.disabled = true;
          if (next) next.disabled = true;
          updateProgressFromScroll();
          return;
        }

        if (viewport) viewport.scrollLeft = 0;
        const max = maxIndex();
        if (index > max) index = max;
        const first = slides[0];
        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const step = first.getBoundingClientRect().width + gap;
        track.style.transform = 'translate3d(' + -index * step + 'px, 0, 0)';

        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= max;
        if (progress) progress.hidden = true;
      };

      if (prev) {
        prev.addEventListener('click', () => {
          index -= 1;
          update();
        });
      }
      if (next) {
        next.addEventListener('click', () => {
          index += 1;
          update();
        });
      }

      if (viewport) {
        viewport.addEventListener(
          'scroll',
          () => {
            if (!isDesktop()) updateProgressFromScroll();
          },
          { passive: true }
        );
      }

      window.addEventListener('resize', update);
      update();
    };

    const boot = (root) => {
      fillReviews(root).finally(() => {
        delete root.dataset.reviewsReady;
        init(root);
      });
    };

    const start = () => {
      document.querySelectorAll('[data-powdi-reviews]').forEach(boot);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-powdi-reviews]');
      if (!root) return;
      delete root.dataset.reviewsReady;
      delete root.dataset.reviewsLoading;
      boot(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
